import { toZonedTime } from 'date-fns-tz';
import { useEffect, useState } from 'react';
import { HOUR_HEIGHT, ROW_SPACER_HEIGHT } from '../../constants';
import { useGetHoursOfDay } from '../../hours';

type Properties = {
  timezone: string;
};

export const useCalculateNowPosition = ({ timezone }: Properties) => {
  const [top, setTop] = useState(0);
  const hours = useGetHoursOfDay();

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const zonedNow = toZonedTime(now, timezone);
      const h = zonedNow.getHours();
      const m = zonedNow.getMinutes();
      const index = hours.indexOf(h);

      setTop(index * HOUR_HEIGHT + (m / 60) * HOUR_HEIGHT + ROW_SPACER_HEIGHT);
    };

    updateTime();
    const interval = setInterval(updateTime, 60 * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [hours, timezone]);

  return { top };
};
